export const sidebarMessages = {
  en: {
    dashboard: 'Dashboard',
    dashboardOverview: 'Overview',
    diagrams: 'Diagrams',
    diagramsHostLookup: 'Host to Gateway path',
    diagramsNetwork: 'Network',
    diagramsPathLookup: 'End to end path',
    diagramsRouting: 'Routing',
    diagramsSites: 'Site Diagrams',
    diagramsSwitching: 'Switching',
    extensions: 'Extensions',
    snapshotManagement: 'Discovery Snapshot',
    inventory: 'Inventory',
    management: 'Management',
    managementChanges: 'Changes',
    managementConfiguration: 'Configuration',
    managementDiscoveryHistory: 'Discovery History',
    managementSavedConfigConsistency: 'Saved Config Consistency',
    monitoring: 'Monitoring',
    monitoringStates: 'States',
    monitoringTargets: 'Targets',
    reports: 'Reports',
    reportsHistory: 'History',
    reportsHistoryNetwork: 'Network Analysis Report',
    reportsHistorySites: 'Site Low Level Design',
    settings: 'Settings',
    settingsAdministration: 'Administration',
    settingsGlobalDiscoveryConfiguration: 'Global Configuration',
    settingsAdvancedCli: 'SSH/Telnet',
    settingsAdvancedConfigMgmt: 'Configuration Management',
    settingsAdvancedDiscovery: 'Discovery',
    settingsAdvancedSnapshots: 'Snapshots',
    settingsApiTokens: 'API Tokens',
    settingsBackupMaintenance: 'Backup & Maintenance',
    settingsCertificationAuthorities: 'Certificate Authorities',
    settingsConfigurationWizard: 'Configuration Wizard',
    settingsDiscoverySnapshots: 'Discovery & Snapshots',
    settingsGlobalDiscoverySettings: 'Discovery Settings',
    settingsDiscoveryDataEnrichment: 'Discovery Data Enrichment',
    settingsSnapshotCollection: 'Snapshot Collection',
    settingsIpfCertificates: 'IPF Certificates',
    settingsIntegration: 'Integration',
    settingsMcpServer: 'MCP Server',
    settingsConfigurationManagement: 'Configuration Management',
    settingsSnmp: 'SNMP',
    settingsSystem: 'System',
    settingsUserManagementLdap: 'LDAP',
    settingsUserManagementLocalUsers: 'Local Users',
    settingsUserManagementRoles: 'Roles',
    settingsUserManagementPolicies: 'Policies',
    settingsWebHooks: 'Webhooks',
    technology: 'Technology',
    menuText: {
      snapshots: 'Current Snapshot',
      snapshotPlaceholderNoSnapshotLoaded: 'No snapshots loaded',
      searchPlaceholder: 'Search...',
    },
  },
};
